export default __webpack_public_path__ + "static/media/klerp-logo.0171dc13.png";